import React, { useContext, useReducer } from "react";

import GlobalContext from "../../isp._comun/iu/contexto/GlobalContext";

import {
    NotificacionToastDeCreacion,
    // NotificacionToastDeError,
} from "../../isp._comun/iu/componentes/widgets/notificacionesToast/NotificacionesToast";

import * as TipoDeError from "../../isp._comun/services/Errores";

import ClienteReducer from "../reductores/ClienteReducer";
import * as Action from "../reductores/acciones/dispatch/_ActionsDispatch";
import CargaDeClienteConsultado from "../reductores/acciones/dispatch/CargaDeClienteConsultado";
import FinalizarComando from "../reductores/acciones/dispatch/FinalizarComando";

import DialogoClienteLayout from "./layouts/DialogoClienteLayout";

import ComandoAPI from "../../isp._comun/iu/componentes/ComandoAPI";
import { TipoDeCliente } from "../../isp.žapi.clientes/constantesApiClientes";
import DataDeRespuestas_de_Cliente from "../../isp.žapi.clientes/DataEstaticaDeRespuestas.json";
import ServiceRegistroDeCliente from "../../isp.žapi.clientes/ServiceRegistroDeCliente";
import ServiceActualizacionDeCliente from "../../isp.žapi.clientes/ServiceActualizacionDeCliente";
import ServiceQueryUnCliente from "../../isp.žapi.clientes/ServiceQueryUnCliente";

const DialogoCliente = ({ ventana }) => {
    const {
        // estadoPrin,
        // dispatchPrincipal,
        // cargarPantallaLogin,
        handleErroresExtraEnPrincipal,
        notificar,
    } = useContext(GlobalContext);

    //actualiza estadoInicial de la entrada si hay algun input
    /* let funcionEstadoInicial = null;
    if(ventana.estadoCom.flag.modoOperacion === ModosOp.CREAR){
        funcionEstadoInicial = Estado.getEstadoInicial;
    }
    if(ventana.estadoCom.flag.cargandoEntidad){
        const estadoInicial = Estado.getEstadoInicial();
        funcionEstadoInicial = () =>{
            estadoInicial.flag.modal=
        }
    }
    const [estadoDCF, dispatchDCF] = useReducer(FactReducer, null, funcionEstadoInicial); */
    // const [estadoDCF, dispatchDCF] = useReducer(FactReducer, estadoInicial);
    // const [estadoDCF, dispatchDCF] = useReducer(FactReducer, Estado.getEstadoInicial());
    // const estadoDCF = ventana.estadoDCF;

    /* if (
        estadoDCF.flag.iniciando &&
        ventana.estadoCom.flag.modoOperacion !== ModosOp.CREAR
        ) {
            const estadoInicial = ventana.estadoCom
            ventana.estadoCom = estadoDCF;
            ventana.dispatch = dispatchDCF;
            dispatchDCF(new EsperarClienteConsultado(estadoInicial));
            return;
        } */

    const [estadoDCF, dispatchDCF] = useReducer(ClienteReducer, ventana.estadoComp);

    const serviceApiRegistrarCliente = new ServiceRegistroDeCliente();
    const registrarClienteCommand = new ComandoAPI(serviceApiRegistrarCliente);
    registrarClienteCommand.ejecutar = async () => {
        let bloqueIdentificacion;
        if (estadoDCF.domain.screen.tipoCliente === TipoDeCliente.DocId) {
            bloqueIdentificacion = {
                tipoDoc: estadoDCF.domain.screen.tipoDoc,
                nroDoc: estadoDCF.domain.screen.nroDoc,
                nombres: estadoDCF.domain.screen.nombres,
                apellidos: estadoDCF.domain.screen.apellidos,
                sexo: estadoDCF.domain.screen.sexo,
            };
        } else {
            bloqueIdentificacion = {
                razonSocial: estadoDCF.domain.screen.razonSocial,
                ruc: estadoDCF.domain.screen.ruc,
            };
        }
        const clienteAFact = {
            tipoCliente: estadoDCF.domain.screen.tipoCliente,
            ...bloqueIdentificacion,

            general: {
                telcel1: estadoDCF.domain.screen.general.telcel1,
                telcel2: estadoDCF.domain.screen.general.telcel2,
                telfijo: estadoDCF.domain.screen.general.telfijo,
                email: estadoDCF.domain.screen.general.email,
                sitioWeb: estadoDCF.domain.screen.general.sitioWeb,
            },
            /*
            cobranza: {
                modoCobro: estadoDCF.modoCobro,
                tipoComprobante: estadoDCF.tipoComprobante,
                cicloFact: estadoDCF.cicloFact,
            },*/
            contactos: [...estadoDCF.domain.screen.contactos.data],
            
            /*personasContacto: estadoDCF.personasContacto.contactosAct, */
        };
        // Object.setPrototypeOf(clienteAFact, ClienteAFacturar.prototype);

        try {
            const dataRegistradaDeClienteAFacturar = await serviceApiRegistrarCliente.ejecutar(
                clienteAFact
            );
            dispatchDCF(new Action.CargaDeClienteRegistrado(dataRegistradaDeClienteAFacturar));
            notificar(
                new NotificacionToastDeCreacion(
                    DataDeRespuestas_de_Cliente.CreacionClienteAFacturar.titulo,
                    DataDeRespuestas_de_Cliente.CreacionClienteAFacturar.mensaje,
                    dataRegistradaDeClienteAFacturar.idCliente
                )
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                dispatchDCF(new Action.CargaDeErroresDelDominioAlCrearCliente(error.data));
                return;
            }

            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());
            }
            handleErroresExtraEnPrincipal(error);
        }
    };
    // });

    const serviceApiActualizacionDeCliente = new ServiceActualizacionDeCliente();
    const actualizarClienteCommand = new ComandoAPI(serviceApiActualizacionDeCliente);
    actualizarClienteCommand.ejecutar = async () => {
        const clienteAFactPorActualizar = {
            id: estadoDCF.domain.screen.idCliente,
            data: estadoDCF.domain.update,
        };

        try {
            await serviceApiActualizacionDeCliente.ejecutar(clienteAFactPorActualizar);
            dispatchDCF(
                new Action.CargaDeClienteActualizado()
            );

        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                dispatchDCF(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }
            
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());
            }
            handleErroresExtraEnPrincipal(error);
        }
    };
    // });

    const serviceApiQueryUnCliente = new ServiceQueryUnCliente();
    const buscarUnSoloClienteCommand = new ComandoAPI(serviceApiQueryUnCliente);
    buscarUnSoloClienteCommand.ejecutar = async (idCliente) => {
        try {
            // const respuestaQuery = await new ServicioDeQueryDeUnClienteAFacturar().ejecutar("undefinido");
            const respuestaQuery = await serviceApiQueryUnCliente.ejecutar(idCliente);
            dispatchDCF(new CargaDeClienteConsultado(respuestaQuery.cliente));
            // ventana.ventanaCargando.dispatch(new CargaDeClienteConsultado(respuestaQuery.cliente));
            // dispatchQ(new CargaDeClientesBuscados(respuestaQuery.clientes));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            handleErroresExtraEnPrincipal(error);
        }
    };
    // });

    return (
        <DialogoClienteLayout
            ventana={ventana}
            estadoDCF={estadoDCF}
            dispatchDCF={dispatchDCF}
            registrarClienteCommand={registrarClienteCommand}
            actualizarClienteCommand={actualizarClienteCommand}
            buscarUnSoloClienteCommand={buscarUnSoloClienteCommand}
        />
    );
};

export default DialogoCliente;
